import React from 'react';
import clsx from 'clsx';
import { Box, makeStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';
import AppButton from 'src/components/AppButton';
import AppInput from 'src/components/AppInput';
import AppSelect from 'src/components/AppSelect';
import AppDatePicker from 'src/components/AppDatePicker';
import { required, namePattern, emailPattern } from 'src/util/validation';

const useStyles = makeStyles((theme: Theme) => ({
  btn: {
    textTransform: 'capitalize',
    padding: `${theme.spacing(0.75)}px ${theme.spacing(3)}px`
  }
}));

interface ProfileFormProps {
  onSubmit?: (data: any) => void;
}

const ProfileForm: React.FC<ProfileFormProps> = ({ onSubmit }) => {
  const classes = useStyles();
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'all',
    defaultValues: {
      full_name: '',
      email: '',
      gender: '',
      dob: ''
    }
  });
  const handleFormSubmit = (data: any) => {
    if (onSubmit) onSubmit(data);
  };
  return (
    <Box>
      <Box p={4}>
        <form>
          <AppInput
            id="name"
            type="text"
            name="full_name"
            label="Name"
            placeholder="Enter name"
            validation={{
              required,
              pattern: namePattern
            }}
            error={errors.full_name}
            control={control}
            py={1.5}
            showErrorOnTouch={true}
          />
          <AppInput
            id="email"
            type="text"
            name="email"
            label="Email address"
            placeholder="Enter email address"
            validation={{
              required,
              pattern: emailPattern
            }}
            error={errors.email}
            control={control}
            py={1.5}
            showErrorOnTouch={true}
          />
          <AppSelect
            id="gender"
            type="text"
            name="gender"
            label="Gender"
            placeholder="Select gender"
            validation={{
              required
            }}
            error={errors.gender}
            control={control}
            py={1.5}
            options={[
              { label: 'Male', value: '1' },
              { label: 'Female', value: '2' }
            ]}
            showErrorOnTouch={true}
          />
          <AppDatePicker
            id="date-of-birth"
            name="dob"
            label="Date of birth"
            validation={{
              required
            }}
            error={errors.dob}
            control={control}
            py={1.5}
            showErrorOnTouch={true}
          />
        </form>
        <Box mt={3}>
          <AppButton
            className={clsx('primary', classes.btn)}
            onClick={handleSubmit(handleFormSubmit)}
          >
            Submit
          </AppButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileForm;
